import { ControlType, FormFieldBase } from './form-field-base.model';

export class ChipsFormField extends FormFieldBase<string> {
  controlType: ControlType = 'chips';
}
